import { Loader2 } from "lucide-react";
import { AppIcon } from "./AppIcon";
import { useQuery } from "convex/react";
import { api } from "../../api";

interface AppIdDisplayProps {
  appId: string;
  onlyIcon?: boolean;
}

export const AppIdDisplay = ({ appId, onlyIcon = false }: AppIdDisplayProps) => {
  // Fetch the app data using the apps.get.apps endpoint
  const appsData = useQuery(api.apps.get.apps, {
    apps: [appId as any]
  });

  const app = appsData?.[0];
  const isLoading = appsData === undefined;

  if (isLoading) {
    return onlyIcon ? (
      <div className="w-8 h-8 flex items-center justify-center bg-muted rounded-lg">
        <Loader2 className="w-4 h-4 animate-spin text-muted-foreground" />
      </div>
    ) : (
      <div className="flex items-center">
        <div className="w-8 h-8 flex items-center justify-center bg-muted rounded-lg mr-3">
          <Loader2 className="w-4 h-4 animate-spin text-muted-foreground" />
        </div>
        <div>
          <div className="font-medium text-foreground">Loading...</div>
          <div className="text-sm text-muted-foreground">{appId.slice(0, 8)}...</div>
        </div>
      </div>
    );
  }

  const displayName = app?.name || appId;
  const iconUrl = app?.iconUrl;
  const bundleId = app?.bundleId;

  if (onlyIcon) {
    return <AppIcon app_icon_url={iconUrl} app_name={displayName} />;
  }

  return (
    <div className="flex items-center">
      <div className="mr-3">
        <AppIcon app_icon_url={iconUrl} app_name={displayName} />
      </div>
      <div>
        <div className="font-medium text-foreground">{displayName}</div>
        {bundleId && <div className="text-sm text-muted-foreground">{bundleId}</div>}
      </div>
    </div>
  );
};
